/**
 * Utility interfaces, functions.
 * Use `apply` method to in your component to use them.
 */

/**
 * Add value to the current attribute.
 * For example: class property
 *
 * @param name
 * @param value
 */
function addValueToAttribute(name, value) {
    let currentAttributeValue = this.getAttribute(name) ? this.getAttribute(name): '';

    if (_doesAttributeValueAlreadyExists(value, currentAttributeValue)) {
        return;
    }

    currentAttributeValue = (currentAttributeValue + ' ' + value).trim();
    this.setAttribute(name, currentAttributeValue);
}

/**
 * Remove value from the current attribute.
 * For example: class property.
 *
 * @param name
 * @param value
 */
function removeValueFromAttribute(name, value) {
    let currentAttributeValue = this.getAttribute(name) ? this.getAttribute(name): '';

    if (!_doesAttributeValueAlreadyExists(value, currentAttributeValue)) {
        return;
    }

    currentAttributeValue = currentAttributeValue.replace(value, '');
    this.setAttribute(name, currentAttributeValue);
}

/**
 * Checks if a value exists in the current property value.
 *
 * @param value
 * @param currentAttributeValue
 * @returns {boolean}
 */
function _doesAttributeValueAlreadyExists(value, currentAttributeValue) {
    let doesExists = false;

    let pattern = new RegExp('\\b' + value + '\\b');

    if (pattern.test(currentAttributeValue)) {
        doesExists = true;
    }

    return doesExists;
}

/**
 * Adds link tag to the component to include external CSS.
 * This could be component CSS or global CSS files.
 *
 * @param linkRelativeUrl
 */
function addStyle(linkRelativeUrl) {
        let styleLink = document.createElement('link');
        styleLink.type = 'text/css';
        styleLink.href = linkRelativeUrl;
        styleLink.rel = 'stylesheet';

        this.shadowRoot.appendChild(styleLink);
}

/**
 * Loads multiple stylesheets into the shadow root.
 * This is mainly to load multiple styles and wait for all to be loaded before proceeding.
 * 
 * @param {*} shadowRoot 
 * @param {*} paths: array of stylesheet paths
 * @returns 
 */
function loadStylesWithPromise(paths){
    return new Promise((resolve) => {
        let loadedCount = 0;

        paths.forEach((path) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = path;
            link.onload = () => {
                loadedCount++;
                if (loadedCount === paths.length) {
                    resolve();
                }
            };
            this.shadowRoot.appendChild(link);
        });
    });
}

/**
 * Load an external HTML template.
 *
 * @param url
 * @returns {Promise<string>}
 */
async function loadTemplate(url) {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Failed to load template: ${url}`);
    }

    return await response.text();
}

export default {addValueToAttribute, removeValueFromAttribute, addStyle, loadStylesWithPromise, loadTemplate}